// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"426":"b5567287","488":"c3563a08","824":"977561fd"}[chunkId] + ".chunk.js";
};